var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47495 11.3664L7.56018 9.3338C7.29506 9.05395 6.85319 8.99503 6.52916 9.20124L5.29193 9.99661C4.61439 9.24543 4.12833 8.59735 3.657 7.61051C3.14149 6.55002 2.96474 5.75465 2.81745 4.79727L4.20198 4.32595C4.5702 4.20811 4.80587 3.82516 4.74695 3.44221L4.36399 0.70261C4.29035 0.216553 3.81903 -0.0927522 3.3477 0.0250797L1.50657 0.496409C1.07943 0.599512 0.740667 0.938277 0.622835 1.35069C0.505003 1.77783 0.372442 2.33753 0.328255 2.73521C0.180965 4.54687 0.608104 6.63839 1.55076 8.61208C2.49341 10.5858 3.84848 12.2207 5.35084 13.2517C5.6896 13.4874 6.20512 13.723 6.61753 13.8998C7.02995 14.0765 7.50127 14.0176 7.85476 13.7378L9.35712 12.5742C9.76953 12.2796 9.81372 11.7199 9.47495 11.3664Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhon);
export default __webpack_public_path__ + "static/media/phon.55bbf37a5cbf3269cee812fed8d75f6f.svg";
export { ForwardRef as ReactComponent };